import axios from 'axios'
// qs是一个增加了一些安全性的查询字符串解析和序列化字符串的库
import qs from 'qs'
// lodash它内部封装了对字符串、数组、对象等常见数据类型的处理函数的库
import merge from 'lodash/merge'
import { Message } from 'element-ui'

const http = axios.create({
  timeout: 1000 * 30,
  // withCredentials: false,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

window.isTokenRefreshing = false // 是否正在刷新token
/**
 * 请求拦截  发送请求时添加token
 */
http.interceptors.request.use(config => {
  config.headers.Authorization = config.sign
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(res => {
  // 成功接收数据
  if (res.status === 200) {
    return Promise.resolve(res)
  } else {
    return Promise.reject(res)
  }
}, error => {
  // 401  token失效 未认证 跳转到登录页面
  if (error.response && error.response.status) {
    switch (error.response.status) {
      // 0 参数异常
      case 0:
        Message.error('参数异常')
        break
      // 401未授权
      case 401:
        Message.error('未授权')
        break
      //  403登录过期
      case 403:
        Message.error('登录过期')
        break
      // 请求地址不存在
      case 404:
        // 跳转到404页面
        Message.error('404 请求地址不存在')
        break
        // 409  资源冲突
      case 409:
        Message.error('resource conflict！')
        break
      case 500:
        Message.error('server error')
        break
    }
  } else {
    Message.error('网络异常')
  }
  return Promise.reject(error.response)
})

/**
 * 请求地址处理
 * @param {*} action方法名
 */
http.wrapperUrl = (actionName) => {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  // return (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/proxyApi/' : process.env.BASE_URL) + actionName
  return actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} useDefaultParams 是否使用默认参数?
 */
http.wrapperParams = (params = {}, useDefaultParams = false) => {
  var defaults = {
    time: new Date()
  }
  return useDefaultParams ? merge(defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} useDefaultParam 是否使用默认参数?
 * @param {*} contentType 媒体类型
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.wrapperData = (data = {}, useDefaultParams = false, contentType = 'json') => {
  var defaults = {
    time: new Date().getTime()
  }
  data = useDefaultParams ? merge(defaults, data) : data
  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

export default http



// WEBPACK FOOTER //
// ./src/utils/httpWrapper.js